export const feesOptimism = {
    defaultPriorityFee: 1000000n, // 0.001 gwei
};
//# sourceMappingURL=fees.js.map